export const routes = {
  home: '/',
}
